import React from 'react';
import { notifications } from '@mantine/notifications';
// Close notifications on click.
// - Clicking a toast closes it (event delegated on container)
// - As a fallback, any click anywhere also closes visible toasts
const NotificationsController = () => {
    React.useEffect(() => {
        // 1) Event delegation on notifications container: clicking a toast closes toasts
        const container = document.querySelector('.app-notifications');
        const onContainerClick = (e) => {
            try {
                const target = e.target;
                if (!target)
                    return;
                // Mantine wraps each toast with [data-notification]; support class fallback too
                const toastEl = target.closest('[data-notification], [class*="mantine-Notification-root"]');
                if (toastEl) {
                    notifications.clean();
                    try {
                        e.preventDefault();
                    }
                    catch { }
                    try {
                        e.stopImmediatePropagation?.();
                    }
                    catch { }
                    try {
                        e.stopPropagation();
                    }
                    catch { }
                }
            }
            catch { }
        };
        if (container) {
            container.addEventListener('click', onContainerClick, true);
            container.addEventListener('pointerdown', onContainerClick, true);
            container.addEventListener('touchstart', onContainerClick, true);
        }
        // 2) Fallback: if any click happens anywhere and there are visible toasts, close them
        const hasToasts = () => !!document.querySelector('.app-notifications [data-notification], .app-notifications [class*="mantine-Notification-root"]');
        const closeAndSwallow = (e) => {
            try {
                if (hasToasts()) {
                    notifications.clean();
                    try {
                        e.preventDefault();
                    }
                    catch { }
                    try {
                        e.stopImmediatePropagation?.();
                    }
                    catch { }
                    try {
                        e.stopPropagation();
                    }
                    catch { }
                }
            }
            catch { }
        };
        window.addEventListener('pointerdown', closeAndSwallow, true);
        window.addEventListener('click', closeAndSwallow, true);
        window.addEventListener('touchstart', closeAndSwallow, true);
        return () => {
            if (container) {
                container.removeEventListener('click', onContainerClick, true);
                container.removeEventListener('pointerdown', onContainerClick, true);
                container.removeEventListener('touchstart', onContainerClick, true);
            }
            window.removeEventListener('pointerdown', closeAndSwallow, true);
            window.removeEventListener('click', closeAndSwallow, true);
            window.removeEventListener('touchstart', closeAndSwallow, true);
        };
    }, []);
    return null;
};
export default NotificationsController;
